import { useState } from 'react';

/**
 * Custom hook para gestionar el estado de un modal de formulario
 * @returns {Object} Estado y funciones del modal
 */
function useFormModal() {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedForm, setSelectedForm] = useState(null);

    const open = (task, form = null) => {
        setSelectedTask(task);
        setSelectedForm(form);
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
        setSelectedTask(null);
        setSelectedForm(null);
    };

    return {
        isOpen,
        selectedTask,
        selectedForm,
        open,
        close,
        setSelectedForm // Para casos donde el form se carga async después de abrir
    };
}

export default useFormModal;
